import isArray from 'lodash/isArray';
import sortBy from 'lodash/sortBy';
import React from 'react';

import { IEntity } from '../../../data/types';
import { isNumOrStr } from '../../../utils/isNumOrStr';
import { ListAvatar } from '../../shared/List/ListAvatar';
import { TooltipWrapper } from '../utils/Utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultFormatter = (value: any): string =>
  isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1])
    ? value.join(' ~ ')
    : value;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const QuadrantTooltip = (props: any): React.ReactElement => {
  const { payload, separator, formatter, itemStyle, itemSorter } = props;

  if (payload && payload.length) {
    const listStyle = { padding: 0, margin: 0 };
    let entity: IEntity;

    const items = (itemSorter ? sortBy(payload, itemSorter) : payload).map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (entry: any, index: number): React.ReactElement => {
        if (entry.type === 'none') {
          return null;
        }
        const finalItemStyle = {
          display: 'block',
          color: 'var(--color-text)',
          ...itemStyle,
        };
        const finalFormatter = entry.formatter || formatter || defaultFormatter;
        const { name } = entry;
        entity = !entity ? (entry.payload.entity as IEntity) : entity;
        const value = entry.payload[`${name}-val`];

        return (
          <React.Fragment key={`tooltip-item-${index}`}>
            <li className='recharts-tooltip-item' style={finalItemStyle}>
              {isNumOrStr(entry.name) ? (
                <span className='recharts-tooltip-item-name'>{entry.name}</span>
              ) : null}
              {isNumOrStr(entry.name) ? (
                <span className='recharts-tooltip-item-separator'>
                  {separator}
                </span>
              ) : null}
              <span className='recharts-tooltip-item-value'>{value}</span>
              <span className='recharts-tooltip-item-unit'></span>
            </li>
          </React.Fragment>
        );
      }
    );

    return (
      <TooltipWrapper>
        <ul className='recharts-tooltip-item-list' style={listStyle}>
          <ListAvatar entity={entity} />
          {items}
        </ul>
      </TooltipWrapper>
    );
  }

  return null;
};
